import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Contacts</h1>
      <p>Homes for Haringey can be contacted at <a href="https://www.homesforharingey.org/contact-us-0">https://www.homesforharingey.org/contact-us-0</a></p>

    </React.Fragment>
  );
}
